module.exports = __webpack_public_path__ + "img/11.3a403227.jpg";